function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="35" height="35" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M35 0l-.041 35H20.43v-4.503h10.03V4.503H4.58v9.006H0V0h35zM15.69 16.897V35h-4.518v-7.155H4.518V35H0V16.897h4.518v6.853h6.654v-6.853h4.518z" fill="#4B2118" /></svg>;
});